import { useState } from 'react';
import { Autocomplete, TextField, Chip } from '@mui/material';
import './TagsInput.scss';

function TagsInput({ tags, onChange, label = "תגיות", placeholder = "הקלד תגית ולחץ אנטר להוספה", autocompleteOptions = [], icon }) {
  const [inputValue, setInputValue] = useState('');

  const handleRemoveTag = (tagToRemove) => {
    const newTags = tags.filter(tag => tag !== tagToRemove);
    onChange(newTags);
  };

  return (
    <div className="tags-input-wrapper">
      {icon && (
        <div className="tags-input-icon">
          <img src={icon} alt="" />
        </div>
      )}
      <Autocomplete        
        multiple
        freeSolo
        options={autocompleteOptions.filter(option => !tags.includes(option))}
        disableClearable={true}
        value={tags}
        inputValue={inputValue}
        onInputChange={(event, newInputValue) => {
          setInputValue(newInputValue);
        }}
        onChange={(event, newValue) => {
          onChange(newValue);
        }}
        onBlur={() => {
          if (inputValue.trim() !== '' && !tags.includes(inputValue.trim())) {
            onChange([...tags, inputValue.trim()]);
            setInputValue('');
          }
        }}
        renderTags={(value, getTagProps) =>
          value.map((option, index) => {
            const { key, ...otherProps } = getTagProps({ index });
            return (
              <Chip
                key={key}
                label={option}
                {...otherProps}
                onDelete={() => handleRemoveTag(option)}
              sx={{
                backgroundColor: '#1FB5A3',
                color: 'white !important',
                '& .MuiChip-deleteIcon': {
                   margin: '3px 2px 2px 2px !important',
                   color: 'white !important'
                },
              }}
            />
          );
        })
      }
        renderInput={(params) => (
          <TextField
            {...params}
            variant="outlined"
            placeholder={tags.length === 0 ? label : ''}
          />
        )}
        sx={{
          '& .MuiOutlinedInput-root': {
            borderRadius: '8px',
            paddingRight: '48px !important',
            '& fieldset': {
              borderColor: '#E4E7EC',
            },
            '&:hover fieldset': {
              borderColor: '#D0D5DD',
            },
            '&.Mui-focused fieldset': {
              borderColor: '#103C6E',
            },
          },
        }}
      />
    </div>
  );
}

export default TagsInput;
